(function () {
  const calcMinHeight = () => {
		const facetsTop = document.querySelector('.facets__top');
		const sortWrapper = document.querySelector('.facets__sort-wrapper');
		const collectionWrapper = document.querySelector('.collection-wrapper');

		if (facetsTop && sortWrapper && collectionWrapper) {
			const height = sortWrapper.getBoundingClientRect().height;
      
			// Only set if we have a valid height, otherwise let CSS handle it
			if (height > 0) {
				collectionWrapper.style.gridTemplateRows = height + 'px auto 1fr';
			} else {
				// Remove inline style to let CSS take over
				collectionWrapper.style.gridTemplateRows = '';
			}
		}
	}

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		if (!collectionGridSection) {
			calcMinHeight();
			return;
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	resizeCollectionGrid();

    
})();